var plugin_rtlignore_default = {
  "alignLeft": "hvbFi",
  "textWrapNowrap": "oZ-4b",
  "alignRight": "sZ-E2",
  "alignCenter": "Ga-PV",
  "sizeFullWidth": "hwePB",
  "renderedInTable": "_-0ig2",
  "sizeOriginal": "pbhOl",
  "sizeContent": "zJr-I",
  "sizeSmall": "klDGd",
  "sizeSmallCenter": "msL7J",
  "flex": "_8bFGJ",
  "atomic": "mFG56",
  "embed": "_4TX5V",
  "horizontalScrollbar": "FDjOj",
  "pluginContainerMobile": "mnrrX"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
